import { createGtm } from '@gtm-support/vue-gtm'
import router from '../router'
import CONFIG from '../config/config'

export default createGtm({
  id: CONFIG.GTM_ID,
  debug: false,
  vueRouter: router,
})
